import API from "../API";

export { RegexValidator, RegexValidatorResponse };

class RegexValidator {
  static async validate(regex: string): Promise<RegexValidatorResponse | null> {
    // empty regex always valid
    if (regex === "") {
      return new RegexValidatorResponse({
        extractedField: regex,
        valid: true,
        reason: "",
      });
    }

    // return Promise.resolve({
    //     regex,
    //     reasons: [
    //         'invalid regex',
    //         '    ^ that is the L'
    //     ],
    //     valid: false,
    // });

    return await API.post("/v0/regex/validate", null, {
      regex,
    })
      .then((value: Response) => value.json())
      .then(
        (value: RegexValidateResponseData) => new RegexValidatorResponse(value),
      )
      .catch((error: string) => {
        console.log(error);
        return null;
      });
  }
}

type RegexValidateResponseData = {
  extractedField: string;
  valid: boolean;
  reason: string;
};

class RegexValidatorResponse {
  regex: string;
  valid: boolean;
  reasons: string[];

  constructor(data: RegexValidateResponseData) {
    this.regex = data.extractedField;
    this.valid = data.valid;
    this.reasons = data.reason.split("\n");
  }
}
